/**
* WebSocket Logic
*
* Ex: 
  // Connect
  const { $websocket } = useNuxtApp()
  const { data, send } = $websocket

  // Get data
  watch(data, (newValue) => {
    console.log(JSON.parse(newValue))
  })
  
  // Send Data
  send(JSON.stringify({
    status: 'success', data: {
      url: 'Test', timestamp: new Date().getTime()
    }
  }))
*/

import { useWebSocket } from '@vueuse/core'

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const { confGlobal } = useConfig()
    
    const { data, status, send, open, close } = useWebSocket(confGlobal.webSocketUrl, {
      autoReconnect: true,
      autoClose: true,
      heartbeat: {
        message: JSON.stringify({ type: 'ping' }),
        interval: 1000,
        pongTimeout: 1000
      }
    })

    return {
      provide: {
        websocket: {
          data,
          status,
          send,
          open,
          close
        }
      }
    }
  }
})